import type { ScaleOrdinal } from 'd3-scale';

import { useChartLayoutOrientation } from '../../../../core/components/chart-layout/hooks/useChartLayoutOrientation.js';
import { getLegendOrientation } from '../../../../core/components/chart-layout/utils/orientation.js';
import { ChartLegend } from '../../../../core/components/legend/categorical/ChartLegend.js';
import { buildCategoricalItemsFromScale } from '../../../../core/utils/build-categorical-items-from-scale.js';
import { safeGet } from '../../../../core/utils/safe-get.js';
import { useXYChartColorScales } from '../../../hooks/useXYChartColorScales.js';
import { useXYChartTruncationMode } from '../../../hooks/useXYChartTruncationMode.js';
import type { SeriesId } from '../../../types/xy-chart-internals.js';

export const RectCategoricalLegend = ({ seriesId }: { seriesId: SeriesId }) => {
  const { orientation: layoutOrientation } = useChartLayoutOrientation();
  const orientation = getLegendOrientation(layoutOrientation);
  const scaleColorMap = useXYChartColorScales();
  const { truncationMode } = useXYChartTruncationMode();

  const items = buildCategoricalItemsFromScale(
    safeGet(scaleColorMap, seriesId) as ScaleOrdinal<string, string>,
  );

  return (
    <ChartLegend
      interactionsDisabled
      items={items}
      orientation={orientation}
      truncationMode={truncationMode}
    />
  );
};
